module.exports = __webpack_public_path__ + "static/img/icon.7dd7a1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_13/icon.jpg
// module id = Kzpk
// module chunks = 0